
import Component from 'vue-class-component'
import moduleStore from '../store/migu';
import Vue from 'vue';
import PageState from '../store/state';
import StepText from '../components/stepText.vue';
import StepVideoStyle from '../components/stepVideoStyle.vue';
import StepSpeaker from '../components/stepSpeaker.vue';
import SubmitBtn from '../components/submitBtn.vue';
import WorkTemplate from '../components/workTemplate.vue';
import SimpleLoginPhone from '@/components/SimpleLoginPhone/SimpleLoginPhone.vue';
import {
  toast,
  notLoginMessage,
  notLoginErrorMessage,
} from '@/utils/util';
import { MiguConfig, newYearUrl } from '../utils/constant';
import to from 'await-to-js';
import activityBanner from '@/assets/images/cyberpunkbanner.png';

/**components**/
@Component({
  components: {
    StepText,
    StepVideoStyle,
    StepSpeaker,
    SubmitBtn,
    WorkTemplate,
    SimpleLoginPhone,
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class textToVideoThirdPartPage extends Vue implements IvuePage<PageState> {
  state = new PageState();
  self: Vue = this;

  anchor = ''; // 锚点，定位到创作广场用
  isSubmiting = false;
  taskId = ''; // 任务id
  text = '';  // 默认文本
  styleCode = ''; // 默认视频风格
  speakerName = ''; // 默认发音人名称
  speakerStyleId = 0; // 默认发音人风格id
  speakerStyleName = ''; // 默认发音人风格名称，创作同款用
  speechSpeed = ''; // 默认语速
  localStorageKey = 'textToVideoMiguData'; // 用于所有数据回显，跳转发音人搜索页、登录、支付、获取taskId页返回后回显
  submitParamsKey = 'textToVideoMiguSubmitData'; // 用于保存提交数据，获取taskId返回后直接提交传参
  submitKey = 'isMiguSubmit'; // 用于判断是否是提交
  textSaveKey = 'miguText'; // 用于文案缓存保存
  newYearUrl = newYearUrl;
  activityBanner = activityBanner;
  showLoginPopup = false; // 控制登录弹窗显示



  get isNewYear() {
    return this.state.theme === 'New_Year';
  }

  get commonPub() {
    return this.$store.getters['miguPage/getCommonPub'];
  }
  get textTitle() {
    return this.isNewYear ? '故事创作' : '第1步，请输入文案';
  }
  get styleTitle() {
    return this.isNewYear ? '我的故事风格' : '第2步，选择视频风格与参数';
  }
  get speakerTitle() {
    return this.isNewYear ? '讲述故事声音' : '第3步，选择发音人和语速';
  }
  // 文本参数
  get textParams() {
    if(!this.$refs.stepTextRef) return {};
    return (this.$refs.stepTextRef as any).submitParams || {};
  }

  // 视频风格参数
  get videoStyleParams() {
    if(!this.$refs.stepVideoStyleRef) return {};
    return (this.$refs.stepVideoStyleRef as any).submitParams || {};
  }

  // 发音人参数
  get speakerParams() {
    if(!this.$refs.stepSpeakerRef) return {};
    return (this.$refs.stepSpeakerRef as any).submitParams || {};
  }

  // 获取提交参数
  getParams() {
    const { text, wordLimit } = this.textParams;
    const { speaker, speakerStyle, speechSpeed } = this.speakerParams;
    const { styleCode, scaleCode, effectCode } = this.videoStyleParams;
    const params: any = {
      creationTaskId: this.taskId,
      originContent: text,
      title: text.slice(0, 80),
      wordLimit,
      styleCode,
      scaleCode,
      effectCode,
      speaker,
      speakerStyle,
      speechSpeed,
      platform: 'MIGU', // UNKNOWN :未知 0 ,MINI :微信小程序 1 ,APP :APP 2 ,PC_BOKAN :博看网 10, MIGU :咪咕 11
      resourceType: 'ONE_CLICK',
      articleTransform: 0,
    };
    return params;
  }
  async beforeSumitVerify(params?: any) {
    const bodyParams = params ? params : this.getParams();
    if(!bodyParams.originContent) {
      toast('请输入文案');
      return false;
    }
    if (bodyParams.originContent.length < 35) {
      toast('请输入至少35个字');
      return false;
    }
    if(!bodyParams.speaker) {
      toast('请选择发音人');
      return false;
    }
    const lastArticleId = localStorage.getItem('miguLastArticleId');
    if (lastArticleId) {
      const [error, res] = await to(this.$http("getArticleStatus", { articleId: lastArticleId }));
      if (!error && res.code === 200 && res.data) {
        const status = res.data.status; // 5失败, 6成功
        const lastExportTaskStatus = res.data.lastExportTaskStatus;// 2成功,3/4失败
        if (status === 5 || (status === 6 && [2, 3, 4].includes(lastExportTaskStatus))) {
          localStorage.removeItem('miguLastArticleId');
          // try {
          //   if ((window as any)._amberTrack && ![3, 4].includes(lastExportTaskStatus)) {
          //     (window as any)._amberTrack('music_aigc_complete_task', [
          //       {
          //         EK: 'triggerType',
          //         EV: '2'
          //       },
          //       {
          //         EK: 'scene',
          //         EV: 'AI_CMWW_YYGS'
          //       },
          //       {
          //         EK: 'videoUrl',
          //         EV: res.data.lastExportVideoUrl || ''
          //       }
          //     ]);
          //   }
          // } catch (error) {
            
          // }
        } else {
          toast('已有处理中的任务, 请稍后再次提交');
          return false;
        }
      }
    }
    return true;
  }
  // 检查登录
  checkLogin() {
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      const btoken = localStorage.getItem('btoken');
      if (!btoken) {
        this.showLoginPopup = true;
        return false;
      }
    }
    return true;
  }

  // 提交
  async doSubmit(params?: any) {
    if (this.isSubmiting) return;
    if (!this.checkLogin()) return;
    const bodyParams = params ? params : this.getParams();
    const verify = await this.beforeSumitVerify(bodyParams);
    if (!verify) return;
    this.isSubmiting = true;

    try {
      if ((window as any).getMiguToken) {
        const rcToken = await (window as any).getMiguToken();
        bodyParams.rcToken = rcToken;
      }
    } catch (e) {
      console.error('getMiguToken error', e);
    }

    bodyParams.channelCode = MiguConfig.schannel;
    console.log(bodyParams,"bodyParams")
    this.$http('submitCreate', bodyParams).then(res => {
      this.isSubmiting = false;
      if (res.code == 200) {
        this.isSubmiting = true;
        try {
          if ((window as any)._amberTrack) {
            // 将 creationTaskId 存入本地
            localStorage.setItem('creationTaskIdMigu', bodyParams.creationTaskId + '');
            const vuid = localStorage.getItem('vuid') || '';
            (window as any)._amberTrack('music_aigc_submit_task', [
              {
                EK: 'triggerType',
                EV: '2'
              },
              {
                EK: 'scene',
                EV: MiguConfig.projectId
              },
              {
                EK: 'taskId',
                EV: bodyParams.creationTaskId
              },
              {
                EK: 'vuid',
                EV: vuid
              },
              {
                EK: 'appId',
                EV: MiguConfig.appid
              },
              {
                EK: 'channel',
                EV: MiguConfig.schannel
              }
            ], true, 'beacon');
            console.log('_amberTrack music_aigc_submit_task',
            {
              EK: 'taskId',
              EV: bodyParams.creationTaskId
            },
            {
              EK: 'vuid',
              EV: vuid
            });
          }
        } catch (error) {
          console.log(error);
        }
        //跳转生成状态页面
        localStorage.setItem('miguLastArticleId', res.data.articleId + '');
        this.$router.push({ path: '/audioCreating', query: { articleId: res.data.articleId, source: 'app_migu' } });
      } else if (res.message == notLoginMessage) {
        this.doLogin();
      } else {
        toast(res.message);
      }
    }).catch(err => {
      this.isSubmiting = false;
      if (err?.response?.data?.message === notLoginErrorMessage) {
        this.doLogin();
      }
    })
  }

  async getUserInfo() {
    const [err, res] = await to( this.$http('getMiguUser'));
    try {
      const didLogin = localStorage.getItem('miguDidLogin') === '1';
      const btoken = (localStorage.getItem('btoken') || (typeof this.$route.query.btoken === 'string' ? this.$route.query.btoken : '')) as string;
      const vuid = (localStorage.getItem('vuid') || (typeof this.$route.query.vuid === 'string' ? this.$route.query.vuid : '')) as string;
      console.log('didLogin', didLogin);
      if (didLogin) {
        if ((window as any)._amberTrack && btoken && vuid) {
          setTimeout(() => {
            console.log('_amberTrack music_aigc_login',
              {
                EK: 'loginResult',
                EV: (err || res.code !== 200) ? '1' : '0'
              },
              {
                EK: 'vuid',
                EV: vuid
              });
            (window as any)._amberTrack('music_aigc_login', [
              {
                EK: 'triggerType',
                EV: '2'
              },
              {
                EK: 'scene',
                EV: MiguConfig.projectId
              },
              {
                EK: 'loginResult',
                EV: (err || res.code !== 200) ? '1' : '0'
              },
              {
                EK: 'vuid',
                EV: vuid
              },
              {
                EK: 'appId',
                EV: MiguConfig.appid
              },
              {
                EK: 'channel',
                EV: MiguConfig.schannel
              }
            ], true, 'beacon');
          }, 500);
        }
        localStorage.removeItem('miguDidLogin');
      }
      if (err || res.code !== 200) {
        console.log('getUserInfo error', err || res.message);
      } else if ((window as any)._amberTrack) {
        console.log('_amberTrack music_aigc_enter',
        {
          EK: 'vuid',
          EV: vuid
        });
        (window as any)._amberTrack('music_aigc_enter', [
          {
            EK: 'triggerType',
            EV: '1'
          },
          {
            EK: 'scene',
            EV: MiguConfig.projectId
          },
          {
            EK: 'vuid',
            EV: vuid
          },
          {
            EK: 'appId',
            EV: MiguConfig.appid
          },
          {
            EK: 'channel',
            EV: MiguConfig.schannel
          }
        ], true, 'beacon');
      }
    } catch (e) { }
  }

  // 获取本地存储数据，页面跳转回来时，恢复数据
  getLocalStorageData() {
    const data = JSON.parse(localStorage.getItem(this.localStorageKey));
    if (data) {
      const { text, speakerName, speakerStyle, speakerStyleId, speechSpeed, styleCode } = data;
      this.text = text || '';;
      this.speakerName = speakerName || '';;
      this.speakerStyleId = speakerStyleId || 0;;
      this.speakerStyleName = speakerStyle || '';
      this.speechSpeed = speechSpeed || '';;
      this.styleCode = styleCode || '';;
      localStorage.removeItem(this.localStorageKey);
    }
  }

  // 本地存储数据，跳转其他页面（发音人搜索页）时进行存储
  setLocalStorageData() {
    const { text } = this.textParams;
    const { speakerName, speakerStyleId, speechSpeed } = this.speakerParams;
    const { styleCode } = this.videoStyleParams;
    const data = { text, speakerName, speakerStyleId, speechSpeed, styleCode };
    localStorage.setItem(this.localStorageKey, JSON.stringify(data));
  }

  // 设置migu数据
  setMiguData() {
    localStorage.removeItem('ww_token');
    localStorage.setItem('isMigu', 'true');
    const query = this.$route.query;

    // 锚点，定位到创作广场用
    const anchor = query.anchor || '';
    if (typeof anchor === 'string') this.anchor = anchor;

    // 主题，默认春节主题
    let theme = query.theme || 'Nomal';// 'New_Year';

    // 公共发布标识 commonPub，用于区分页面逻辑和UI
    const commonPub = query.commonPub || localStorage.getItem('commonPub') || '';
    if (typeof commonPub === 'string' && commonPub) {
      theme = 'New_Year';
      (this as any).setCommonPub(commonPub);
      this.state.commonPub = commonPub;
    }

    if (typeof theme === 'string') {
      localStorage.setItem('theme', theme);
      this.state.theme = theme;
    }

    // 咪咕用户数据
    const btoken = query.btoken || localStorage.getItem('btoken') || '';
    const vuid = query.vuid || localStorage.getItem('vuid')  || '';

    if (btoken && vuid && typeof btoken === 'string' && typeof vuid === 'string') {
      localStorage.setItem('btoken', btoken);
      localStorage.setItem('vuid', vuid);
      this.getUserInfo();
      // migu给的参数，除了 btoken 和 vuid，其他参数需要原样回传到视频发布页
      if (query.btoken) {
        const queryString = window.location.href.split('?')[1];
        const params = new URLSearchParams(queryString);
        params.delete('vuid');
        params.delete('btoken');
        localStorage.setItem('queryFromMigu', params.toString());
      }
      if (!btoken) {
        if (!commonPub) { 
          this.doLogin();
        }
        return;
      }
    }
    this.setTaskId();
  }
  
  // 设置taskId
  setTaskId() {
    const isMiguSubmit = localStorage.getItem(this.submitKey);
    if(!isMiguSubmit) return; // 不是提交过来的，不去取taskId
    const query = this.$route.query;
    const taskId = query.taskId || '';
    if(typeof taskId === 'string') this.taskId = taskId;
    if(!taskId) {
      const resumeCode = query.resumeCode || '';
      // 用户支付状态码0：用户支付失败, 1：用户支付成功, 2：用户取消支付, 3：用户已有次数, 4：获取taskId失败
      const error = query.info as string;
      if(resumeCode === '4') {
        let msg = error || '获取taskId失败';
        if (msg.includes('存在进行中的任务')) msg = '存在进行中的任务';
        toast(msg, 'middle', 5000);
      }else if(resumeCode === '2') {
        toast(error || '您已取消支付');
      } else if(resumeCode === '0') {
        toast(error || '支付失败');
      }
      return;
    }
    // 有taskId说明是一键成片跳转来的
    const data = JSON.parse(localStorage.getItem(this.submitParamsKey));
    if (!data) return;
    data.creationTaskId = taskId;
    this.doSubmit(data);
    localStorage.removeItem(this.submitKey);
  }

  async queryTaskId() {
    const isDoSubmit = true;
    // 已有taskId，直接提交
    if (this.taskId && isDoSubmit) {
      this.doSubmit();
      return;
    }
    const verify = await this.beforeSumitVerify();
    if (!verify) return; // 获取taskId前， 进行验证
    // 获取taskId，跳转migu的h5页面，通过cburl跳转回来，并带上taskId
    this.setLocalStorageData(); // 用作内容回显
    if(isDoSubmit) {
      localStorage.setItem(this.submitKey, 'true'); // 用作判断是否接触发提交
      const submitParams = this.getParams(); // 用作跳转回来之后直接触发提交的传参
      localStorage.setItem(this.submitParamsKey, JSON.stringify(submitParams));
    }
    const cburl = encodeURIComponent(window.location.href.split('?')[0]);
    localStorage.setItem('miguDidLogin', '1');
    
    // 获取 btoken
    const btoken = localStorage.getItem('btoken') || '';
    
    // 根据 commonPub 标识决定使用哪个 URL
    if (this.commonPub) {
      let url = `https://y.migu.cn/app/v5/p/middle/ai-channel-task-id/index.html?appId=${MiguConfig.appid}&projectId=${MiguConfig.projectId}&cburl=${cburl}&schannel=${MiguConfig.schannel}`;
      if (btoken) {
        url += `&btoken=${btoken}`;
      }
      url += '&pm=hash#/task-id';
      console.log('queryTaskId', url);
      window.location.href = url;
    } else {
      window.location.href = 
        `https://y.migu.cn/app/v5/p/ai-charging/index.html?appId=${MiguConfig.appid}&projectId=${MiguConfig.projectId}&cburl=${cburl}&schannel=${MiguConfig.schannel}&pm=hash#/task-id`;
    }
  }
  // 跳转登录，migu的h5页面，根据appId跳转回来（在migu那边配置回调地址是正式环境）
  doLogin() {
    this.setLocalStorageData();
    localStorage.setItem('miguDidLogin', '1');
    window.location.href = `https://y.migu.cn/app/v5/p/ai-charging/index.html?appId=${MiguConfig.appid}&schannel=${MiguConfig.schannel}&pm=hash&releaseId=75348636&projectId=${MiguConfig.projectId}`;
  }

  onLoginSuccess(res) {
    this.showLoginPopup = false;
    const {migu_token} = res;
    localStorage.setItem('miguDidLogin', '1');
    window.location.href = `https://y.migu.cn/app/v5/p/middle/ai-channel-token/index.html?appId=${MiguConfig.appid}&schannel=${MiguConfig.schannel}&projectId=${MiguConfig.projectId}&releaseId=75348636&cburl=${encodeURIComponent('https://h5.yuan365.com/#/migu')}&pm=hash&cToken=${migu_token}`;
  }

  closeLogin() {
    this.showLoginPopup = false;
  }
  doPay() {
    this.setLocalStorageData();
    const cburl = encodeURIComponent(window.location.href.split('?')[0]);
    localStorage.setItem('miguDidLogin', '1');
    window.location.href = 
      `https://y.migu.cn/app/v5/p/ai-pay/index.html?appId=${MiguConfig.appid}&projectId=${MiguConfig.projectId}&cburl=${cburl}&schannel=${MiguConfig.schannel}&pm=hash`;
  }

  created() {
    this.setMiguData();
    this.getLocalStorageData();
    this.getLocalStorageText();
  }

  beforeDestroy() {
    this.setLocalStorageText();
  }

  // 文案缓存保存
  setLocalStorageText() {
    if (this.isSubmiting) return; // 是提交，不保存文案
    const { text } = this.textParams;
    localStorage.setItem(this.textSaveKey, text);
  }
  // 文案缓存获取
  getLocalStorageText() {
    const text = localStorage.getItem(this.textSaveKey);
    if (text && !this.text) this.text = text;
    localStorage.removeItem(this.textSaveKey);
  }

  scrollToElement(id, behavior:ScrollBehavior = 'smooth') {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior, block: 'start' });
    }
  }
  doReload() {
    if (!this.checkLogin()) return;
    this.getLocalStorageData();
    this.scrollToElement('step1', 'auto');
    const stepTextRef: any = this.$refs.stepTextRef;
    if(stepTextRef) stepTextRef.isCollapse = false;
  }
  doAnchorTemplate() {
    if (this.anchor !== 'template') return;
    this.scrollToElement('workTemplate');
  }
}
